<template>
  <div class="">
    <div class="">
      <form @submit.prevent="handleLogin">
        <div class="mb-6 mt-12">
          <label
            for="email"
            class="block text-gray-700 text-sm font-medium mb-2"
          >
            E-mail
          </label>
          <input
            v-model="email"
            type="email"
            id="email"
            class="w-full p-4 bg-gray-200 rounded-lg focus:ring-2 focus:ring-blue-400"
            placeholder="Digite seu e-mail"
            required
            aria-label="E-mail"
          />
        </div>

        <div class="mb-6 relative">
          <label for="password" class="block text-sm font-medium mb-2">
            Senha
          </label>
          <div class="relative">
            <input
              v-model="password"
              :type="showPassword ? 'text' : 'password'"
              id="password"
              class="w-full p-4 bg-gray-200 text-gray-900 rounded-lg focus:ring-2 focus:ring-blue-400 pr-12"
              placeholder="Digite sua senha"
              required
              aria-label="Senha"
              autocomplete="current-password"
            />
            <button
              type="button"
              class="absolute right-3 top-1/2 transform -translate-y-1/2 hover:text-gray-900"
              @click="togglePassword"
            >
              <svg
                v-if="!showPassword"
                class="w-5 h-5"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 5C7.5 5 3.73 7.61 2 12c1.73 4.39 5.5 7 10 7s8.27-2.61 10-7c-1.73-4.39-5.5-7-10-7zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                  fill="currentColor"
                />
              </svg>
              <svg
                v-else
                class="w-5 h-5"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 6.5c2.6 0 5.02 1.28 6.5 3.5-1.48 2.22-3.9 3.5-6.5 3.5s-5.02-1.28-6.5-3.5c1.48-2.22 3.9-3.5 6.5-3.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5z"
                  fill="currentColor"
                />
              </svg>
            </button>
          </div>
        </div>

        <div class="flex justify-between items-center mb-6">
          <label class="flex items-center text-sm">
            <input
              v-model="rememberMe"
              type="checkbox"
              class="mr-2 accent-blue-500"
            />
            Manter-me conectado
          </label>
        </div>

        <button
          type="submit"
          class="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 rounded-lg transition flex items-center justify-center gap-2"
          :disabled="loading"
        >
          <svg
            v-if="loading"
            class="animate-spin h-5 w-5 text-white"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M12 2a10 10 0 0110 10h-4a6 6 0 00-6-6V2z"
            ></path>
          </svg>
          <span>{{ loading ? 'Entrando...' : 'Entrar' }}</span>
        </button>
      </form>
      <p v-if="errorMessage" class="text-red-500 text-xs mt-1">
        {{ errorMessage }}
      </p>
      <p v-if="successMessage" class="text-green-500 text-xs mt-1">
        {{ successMessage }}
      </p>

      <p class="text-xs text-gray-400 font-medium text-center mt-6">
        v{{ appVersion }} <span class="mx-1">•</span> Build: {{ buildDate }}
      </p>
    </div>
  </div>
</template>

<script>
import { login } from '@/services/auth/api.auth'
import { VERSION, BUILD_DATE } from '@/config'
const appVersion = VERSION || '1.0.0'
const buildDate = BUILD_DATE || '2025-01-01'

export default {
  name: 'LoginForm',
  data() {
    return {
      email: '',
      password: '',
      rememberMe: false,
      loading: false,
      errorMessage: '',
      successMessage: '',
      showPassword: false,
      appVersion,
      buildDate,
    }
  },
  mounted() {
    const token = localStorage.getItem('Token')
    const role = localStorage.getItem('role')
    const enterprise = localStorage.getItem('enterprise')

    if (token && role) {
      if (role === 'admin') {
        this.$router.push('/admin/dashboard')
      } else if (role === 'employee' && enterprise) {
        this.$router.push(`/${enterprise}`)
      }
    }
  },
  methods: {
    async handleLogin() {
      this.loading = true
      this.errorMessage = ''
      this.successMessage = ''

      try {
        await new Promise((resolve) => setTimeout(resolve, 1))
        const response = await login(this.email, this.password)
        console.log(response.user)

        if (response) {
          const { id, role, Empresa } = response.user
          localStorage.setItem('Name', response.user.name)
          localStorage.setItem('userId', id)
          localStorage.setItem('enterprise', Empresa)
          if (this.rememberMe) {
            localStorage.setItem('Token', response.user.Token)
            localStorage.setItem('role', role)
          }

          this.successMessage = 'Login bem-sucedido! Redirecionando...'

          if (role === 'admin') {
            this.$router.push('/admin/dashboard')
          } else if (role === 'employee') {
            this.$router.push(`/${Empresa}`)
          }
        }
      } catch (error) {
        this.errorMessage = 'Falha ao fazer login. Verifique suas credenciais.'
      } finally {
        this.loading = false
      }
    },
    togglePassword() {
      this.showPassword = !this.showPassword
    },
  },
}
</script>

<style scoped>
button:active {
  transform: scale(0.98);
}

.container-bg {
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
